import {ICurriculumsRepository} from './ICurriculumsRepository';
import * as curriculumsQueries from './CurriculumsQueries';
import {createCurriculum} from './CurriculumsMutations';
import {CurriculumInsert} from '../../graphql/API';
import {generateClient, GraphQLResult} from 'aws-amplify/api';
import {Amplify} from 'aws-amplify';
import {
  InitWithAmplify,
  InitEnvironmentVariable,
  CurriculumsService as PikadoCurriculumsService,
} from '@PikaDoApp/npm-pikado-logic';
import {
  NewCreateCurriculumInput,
  UpdateCurriculumInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/curriculum/graphql/curriculum.interface';
import {getEnvironment} from '../../lib/getEnvironment';

// Initialize the Pikado Logic package
InitWithAmplify(Amplify);
InitEnvironmentVariable(getEnvironment());

const client = generateClient();
const pikadoCurriculumsService = new PikadoCurriculumsService();
export class CurriculumsRepository implements ICurriculumsRepository {
  async getCurriculums(): Promise<any> {
    try {
      // OLD IMPLEMENTATION - COMMENTED OUT (using GraphQL directly)
      // const curriculums: GraphQLResult<any> = await client.graphql({
      //   query: curriculumsQueries.curriculums,
      //   variables: {},
      // });
      // console.log('checkEmail from repository:', curriculums);
      // if (!curriculums.data?.curriculums) {
      //   return [];
      // }
      // return curriculums.data.curriculums.items || [];

      // NEW IMPLEMENTATION - Using @PikaDoApp/npm-pikado-logic package
      const curriculums = await pikadoCurriculumsService.getNewCurriculums();
      if (!curriculums) {
        return [];
      }

      const transformedCurriculums = curriculums.map(curriculum => ({
        ...curriculum,
        id: curriculum._id, // Map _id to id
        type: curriculum.type,
      }));
      if (transformedCurriculums.length > 0) {
      }

      return transformedCurriculums;
    } catch (error) {
      console.error(
        '🔍 [CURRICULUM-NEW-PACKAGE] getCurriculums repository Error:',
        error,
      );
      throw new Error(error);
    }
  }

  async getCurriculumById(id: string): Promise<any> {
    try {
      // NEW METHOD - Using @PikaDoApp/npm-pikado-logic package
      const curriculum = await pikadoCurriculumsService.getCurriculumByID(id);
      if (!curriculum) {
        return null;
      }

      // Transform NewCurriculum to match old Curriculum structure
      // Map _id to id for UI compatibility
      // Handle missing date fields with fallbacks
      const transformedCurriculum = {
        id: curriculum._id,
        createdAt: curriculum.createdAt || new Date().toISOString(),
        updatedAt: curriculum.updatedAt || new Date().toISOString(),
        name: curriculum.name,
        type: curriculum.type,
        program: curriculum.program,
        level: curriculum.level,
        placementTest: curriculum.placementTest, // Include placement tests for edit form
        createdBy: curriculum.createdBy,
      };

      return transformedCurriculum;
    } catch (error) {
      console.error(
        '🔍 [CURRICULUM-NEW-PACKAGE] getCurriculumById repository Error:',
        error,
      );
      throw new Error(error);
    }
  }

  // OLD IMPLEMENTATION - COMMENTED OUT (using GraphQL directly)
  // async createCurriculum(curriculum: CurriculumInsert): Promise<any> {
  //   try {
  //     const createCurriculumResponse: GraphQLResult<any> = await client.graphql(
  //       {
  //         query: createCurriculum,
  //         variables: {
  //           input: curriculum,
  //         },
  //       },
  //     );
  //
  //     return createCurriculumResponse.data?.createCurriculum;
  //   } catch (error) {
  //     console.error('createCurriculumResponse repository Error:', error);
  //     throw new Error(error);
  //   }
  // }

  // OLD IMPLEMENTATION - COMMENTED OUT (keeping for reference)
  // async createCurriculum(curriculum: CurriculumInsert): Promise<any> {
  //   try {
  //     const createCurriculumResponse: GraphQLResult<any> = await client.graphql(
  //       {
  //         query: createCurriculum,
  //         variables: {
  //           input: curriculum,
  //         },
  //       },
  //     );
  //
  //     return createCurriculumResponse.data?.createCurriculum;
  //   } catch (error) {
  //     console.error('createCurriculumResponse repository Error:', error);
  //     throw new Error(error);
  //   }
  // }

  // NEW IMPLEMENTATION - Using @PikaDoApp/npm-pikado-logic package
  async createNewCurriculum(
    curriculum: NewCreateCurriculumInput,
  ): Promise<any> {
    try {
      const createdCurriculum =
        await pikadoCurriculumsService.addNewCurriculum(curriculum);

      if (!createdCurriculum) {
        throw new Error('Failed to create curriculum');
      }

      // Transform response to include oldId for cascade operations
      const transformedCurriculum = {
        id: createdCurriculum._id,
        name: createdCurriculum.name,
        type: createdCurriculum.type,
        program: createdCurriculum.program,
        level: createdCurriculum.level,
        createdAt: createdCurriculum.createdAt || new Date().toISOString(),
        updatedAt: createdCurriculum.updatedAt || new Date().toISOString(),
        createdBy: createdCurriculum.createdBy,
      };

      return transformedCurriculum;
    } catch (error) {
      console.error(
        '🔍 [CURRICULUM-NEW-PACKAGE] createNewCurriculum repository Error:',
        error,
      );
      throw new Error(error);
    }
  }

  // NEW IMPLEMENTATION - Using @PikaDoApp/npm-pikado-logic package
  async updateNewCurriculum(input: UpdateCurriculumInput): Promise<any> {
    try {
      const updatedCurriculum =
        await pikadoCurriculumsService.updateCurriculum(input);

      if (!updatedCurriculum) {
        throw new Error('Failed to update curriculum');
      }

      // Transform response
      const transformedCurriculum = {
        id: updatedCurriculum._id,
        name: updatedCurriculum.name,
        type: updatedCurriculum.type,
        program: updatedCurriculum.program,
        level: updatedCurriculum.level,
        createdAt: updatedCurriculum.createdAt || new Date().toISOString(),
        updatedAt: updatedCurriculum.updatedAt || new Date().toISOString(),
        createdBy: updatedCurriculum.createdBy,
      };

      return transformedCurriculum;
    } catch (error) {
      console.error(
        '🔍 [CURRICULUM-NEW-PACKAGE] updateNewCurriculum repository Error:',
        error,
      );
      throw new Error(error);
    }
  }

  // NEW IMPLEMENTATION - Using @PikaDoApp/npm-pikado-logic package
  async softDeleteNewCurriculum(id: string): Promise<boolean> {
    try {
      const result = await pikadoCurriculumsService.softDeleteCurriculum(id);
      return result;
    } catch (error) {
      console.error(
        '🔍 [CURRICULUM-NEW-PACKAGE] softDeleteNewCurriculum repository Error:',
        error,
      );
      throw error instanceof Error ? error : new Error(String(error));
    }
  }
}
